import React, { Component, useState } from "react";
import '../css/index.css';
import HttpService from "../services/HttpService";
import PromptOpt from "../Components/PromptOptsPagina/PromptOpt"
import Button from "../Components/PromptOptPagina/Button";

class PromptOptsPagina extends Component {
	axios = null;

	state = {
		pageNr: 1,
		entriesPerPage: 25,
		hasNextPage: false,
		promptOpts: [],
		searchString: ""
	}

	componentDidMount() {
		const httpService = HttpService;
		httpService.configure();
		this.axios = httpService.getAxiosClient()
		this.CyclePage(0);
	}

	CyclePage(nrToCycle) {
		var newPageNr = this.state.pageNr + nrToCycle;
		this.setState({ pageNr: newPageNr });
		
		this.axios.get(process.env.REACT_APP_INKOFACT_API_URL + "prompt/?entries=" + this.state.entriesPerPage + "&page=" + newPageNr + "&searchString=" + this.state.searchString).then(response => {
			this.setState({
				promptOpts: response.data.collection,
				hasNextPage: response.data.hasNextPage
			})
		}).catch(() => {
			this.setState({
				promptOpts: []
			})
		})
	}

	OnSearchChangeHandler(searchString) {
		this.setState({ 
			searchString: searchString,
			pageNr: 1
		}, () => this.CyclePage(0));
	}

	OnEntriesChangeHandler(entries){
		this.setState({entriesPerPage: entries}, () => this.CyclePage(0));
	}

	render() {
		return (
			<div className="relative size-full" data-name="Content Box">
				<div className="flex flex-col items-center max-w-inherit min-w-inherit size-full">
					<div className="box-border content-stretch flex flex-col items-center max-w-inherit min-w-inherit px-0 py-2 relative size-full">
						{this.ContentBoxHeader()}
						{this.MainContentFrame()}
					</div>
				</div>
			</div>
		);
	}

	MainContentFrame() {
		return (
			<div className="bg-[rgba(243,244,246,0.75)] relative shrink-0 w-full" data-name="MainContentFrame">
				<div aria-hidden="true" className="absolute border border-gray-400 border-solid inset-0 pointer-events-none" />
				<div className="flex flex-col items-center size-full">
					<div className="box-border content-stretch flex flex-col gap-[10px] items-center px-[28px] py-[10px] relative w-full">
						{this.SearchBarAndButtonFrame()}
						{this.Table()}
						{this.PageCycleFrame()}
					</div>
				</div>
			</div>
		);
	}

	ContentBoxHeader() {
		return (
			<div className="bg-[#00aaad] relative shrink-0 w-full" data-name="ContentBoxHeader">
				<div aria-hidden="true" className="absolute border border-gray-400 border-solid inset-0 pointer-events-none" />
				<div className="flex flex-col items-center justify-center size-full">
					<div className="box-border content-stretch flex flex-col items-center justify-center px-[530px] py-[10px] relative w-full">
						<div className="capitalize flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] not-italic relative shrink-0 text-[20px] text-black text-center tracking-[-0.1px] w-[200px]">
							<p className="leading-[1.45]">Prompt Optimalisaties</p>
						</div>
					</div>
				</div>
			</div>
		);
	}

	SearchBar() {
		return (
			<div className="contents pointer-events-auto sticky top-0" data-name="Search Bar">
				<div className="absolute capitalize flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] left-[22px] not-italic text-[16px] text-black text-center text-nowrap top-[11.5px] tracking-[-0.08px] translate-x-[-50%] translate-y-[-50%]">
					<p className="leading-[1.45] whitespace-pre">Zoek:</p>
				</div>
				<div className="absolute bg-white h-[23px] left-[51px] top-0 w-[320px]">
					<input className="w-full h-full px-2 leading-[1.45] text-black" onChange={e => this.OnSearchChangeHandler(e.target.value)} type="text" placeholder="ontvanger of verzender" />
					<div aria-hidden="true" className="absolute border border-black border-solid inset-0 pointer-events-none" />
				</div>
			</div>
		);
	}

	SearchBarAndButtonFrame() {
		return (
			<div className="content-stretch flex flex-col h-[23px] items-center justify-between relative shrink-0 w-full" data-name="Search Bar and button">
				<div className="absolute bottom-0 left-0 top-0">
					{this.SearchBar()}
				</div>
				<div className="absolute bottom-0 right-0 top-0">
                    <Button text="New" onClick={() => window.location.href = "/PromptOpt/create"} height="23" width="290"/>
				</div>
			</div>
		);
	}

	TableHeader() {
		return (
			<div className="bg-[rgba(58,173,255,0.5)] h-[35px] relative shrink-0 w-full" data-name="TableHeader">
				<div aria-hidden="true" className="absolute border border-black border-solid inset-0 pointer-events-none" />
				<div className="flex flex-row items-center size-full">
					<div className="box-border capitalize content-stretch flex font-['Inter:Bold',sans-serif] font-bold h-[35px] items-center leading-[0] not-italic px-[10px] py-[6px] relative text-[16px] text-black tracking-[-0.08px] w-full">
						<div className="basis-0 flex flex-col grow h-full justify-center min-h-px min-w-px relative shrink-0">
							<p className="leading-[1.45]">Verzender</p>
						</div>
						<div className="basis-0 flex flex-col grow h-full justify-center min-h-px min-w-px relative shrink-0">
							<p className="leading-[1.45]">Ontvanger</p>
						</div>
					</div>
				</div>
			</div>
		);
	}

	Table() {
		return (
			<div className="content-stretch flex flex-col items-center justify-center relative shrink-0 w-full" style={{ textAlign: "left" }} data-name="Table">
				{this.TableHeader()}
				{this.state.promptOpts.map((promptOpt, index) =>
					<PromptOpt key={promptOpt.id}  promptOpt={promptOpt} index={index} />
				)}
			</div>
		);
	}

	PageEntriesBox() {
		return (
			<div className="w-[56px] h-[23px] relative" data-name="Page entries box">
				<div className="bg-white border border-black rounded-sm w-full h-full flex items-center justify-center">
					<input
						id="entriesPerPage"
						type="number"
						onChange={e => this.OnEntriesChangeHandler(e.target.value)}
						className="w-[calc(100%-4px)] h-[calc(100%-4px)] text-center text-sm leading-[1.45] outline-none"
						value={this.state.entriesPerPage}
					/>
				</div>
			</div>
		);
	}

	PageButton(text, nrToCycle) {
		return (
			<div className="w-[42px] h-[23px] relative" data-name="Page button">
				<button className="bg-[#dedede] border-2 border-black rounded-full w-full h-full flex items-center justify-center" onClick={() => this.CyclePage(nrToCycle)}>
					<span className="text-black text-sm font-medium">{text}</span>
				</button>
			</div>
		);
	}

	PageCycleFrame() {
		if(this.state.searchString !== "") { return; }
		var prevPageButton = "";
		if (this.state.pageNr > 1) { prevPageButton = this.PageButton('<<', -1); }
		var nextPageButton = "";
		if (this.state.hasNextPage) { nextPageButton = this.PageButton('>>', 1); }
		return (
			<div className="flex items-center gap-[10px]">
				<span className="text-black text-sm font-medium">Optimalisaties per page:</span>
				{this.PageEntriesBox()}
				{prevPageButton}
				{nextPageButton}
			</div>
		);
	}
} export default PromptOptsPagina